"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonLayout = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const lib_1 = require("../lib");
function getComponent(BB) {
    return ({ component }) => {
        const name = String(component);
        // FIXME: Nasty error in production mode,
        // View is RCTView. Find a more elegant solution in future.
        if (name === 'RCTView') {
            return BB.Components.resolveFromCache('View');
        }
        if (!BB.Components.has(name)) {
            return null;
        }
        return BB.Components.resolveFromCache(name);
    };
}
// tslint:disable: jsdoc-format
/**
 * # 🍱 JsonLayout
 *
 * Renders a Component based on JSON schema. This allows developers to create dynamic
 * layouts in their apps, and even save the schema to databases.
 *
 * Moreover, it also makes that schema filter-able. So that any plugin can modify that schema
 * on runtime.
 *
 * ## Usage:
 * ```jsx
<JsonLayout
    filter="content-filter"
    args={{ style: { color: 'blue' } }}
 schema={{
     component: 'Text',
     props: {
         style: {
             color: 'red'
         }
     },
     text: 'This is the page content.',
 }
} />
 * ```
 */
const JsonLayout = (props) => {
    const BB = core_1.useBlueBase();
    const { filter, schema, args } = props;
    const parser = new lib_1.JsonSchemaParser(getComponent(BB));
    // There's no filter, we don't need to do complex async handling
    if (!filter) {
        return parser.parseSchema(schema);
    }
    const children = (loadedSchema) => parser.parseSchema(loadedSchema);
    return (react_1.default.createElement(components_1.BlueBaseFilter, { filter: filter, value: schema, args: args }, children));
};
exports.JsonLayout = JsonLayout;
exports.JsonLayout.displayName = 'JsonLayout';
